import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  CodeServices,
  IAPIServiceConfigItem,
  IServiceAllEnvs,
  IServiceApplyConfig,
  IServiceApplyInfo,
  IServiceStatus,
  ServiceBusiness,
} from '../../../model/api-modules';
import { IRootState } from '../../../store/reducers';
import { applyService, getServiceApplyInfo } from '../../../api/services';
import { ModalWrap } from '../../component/modal-wrap';
import { GameEnvType, IGameEnvModel } from '../../../model/api-modules/env';
import { Checkbox, Form, Radio, Space, InputNumber } from 'antd';
import {
  messageError,
  messageSuccess,
  messageWarning,
} from '../../../components/message';
import getFormatMessage from '../../../locales/get-format-message';
import './services-apply-modal.scss';
import classNames from 'classnames';
import {
  getLocaleLanguage,
  strToJson,
  LanguageType,
  getUtcTime,
} from '../../../lib';
import { associatedServicesData as associatedServicesJson } from './associated-service';
import warnImage from '../../../assets/images/warn-yellow.png';
import successCircle from '../../../assets/svg/success-circle-fill.svg';
import { openContactMethod } from '../../../lib/email';
import { ServiceShop } from './shop';
import { useHistory } from 'react-router';
// import { ServiceShop } from './shop';
import { AppEnvType, DeployArea } from '../../../model';
import { getConfig, isFeeEnable } from '../../../config';
import { CustomPopover } from '../../../components/custom-popover';
import { auditApplyServiceWriteLog } from '../../lib/aduit-log';
import { isVersionGreaterThan } from '../lib';

interface IProps {
  readonly selectedGameID: string;
  readonly selectedServiceConfig: IAPIServiceConfigItem | null;
  readonly selectedEnv: IGameEnvModel | null;
  readonly onClose: () => void;
  readonly onOk: (success: boolean) => void;
  readonly selectedServerStatus: IServiceStatus[] | null;
  readonly allServicesStatus: Record<string, IServiceStatus[] | null>;
  readonly serviceAllEnvStatus: Record<string, IServiceAllEnvs[] | null>;
}

enum ApplyStep {
  Confirm = 'Confirm',
  Shop = 'Shop',
  FillInfo = 'FillInfo',
  Submit = 'Submit',
}

interface IQPSItem {
  readonly QPS: number;
  readonly RegionID: number;
  readonly ClusterID: number;
}

export const ServicesApplyModal = (props: IProps) => {
  const deployArea: DeployArea = getConfig()?.deployArea;
  const isSingapore = deployArea === DeployArea.singapore;
  const isWoa = deployArea === DeployArea.woa;
  const isCn = deployArea === DeployArea.cn;
  const isEnvProd = getConfig().env === AppEnvType.Production;
  const isEnvPre = getConfig().env === AppEnvType.PreRelease;
  const history = useHistory();
  const selectStudio = useSelector(
    (state: IRootState) => state.studio.selectStudio
  );
  const servicesConfig = useSelector(
    (state: IRootState) => state.games.allServiceConfig
  );

  const [loading, setLoading] = useState<boolean>(false);
  const [step, setStep] = useState<ApplyStep>(ApplyStep.Confirm);
  const [selectServices, setSelectServices] = useState<string[]>([]);
  const [selectRegion, setSelectRegion] = useState<number[]>([]);
  const [regionValues, setRegionValues] = useState<{
    [key: number]: number | null;
  }>({});
  const [isNeedInfo, setIsNeedInfo] = useState<boolean>(false);
  const [serviceInfo, setServiceInfo] = useState<{
    services: string[];
    relevance: string[];
    recommend: {
      [key: string]: string[];
    };
  } | null>(null);
  const [pufferQpsNum, setPufferQpsNum] = useState<number | null>(null);
  const [templateApplyAllStatus, setTemplateApplyAllStatus] =
    useState<boolean>(false); // 子服务是否全部已开通或正在申请
  const [isClose, setIsClose] = useState<boolean>(false); // 是否下线
  const [showConfirmDmp, setShowConfirmDmp] = useState<boolean>(false);
  const [serviceApplyInfo, setServiceApplyInfo] = useState<IServiceApplyInfo[]>(
    []
  );
  const jsonConfig = strToJson<IServiceApplyConfig>(
    props.selectedServiceConfig?.JsonConfig || ''
  );
  const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
  const allServiceConfig = useSelector(
    (state: IRootState) => state.games.allServiceConfig
  );
  const allEnvList = useSelector((state: IRootState) => state.games.allEnvList);
  const [infoForm] = Form.useForm();
  const associatedServicesData = Object.assign({}, associatedServicesJson);
  const serviceRegion = [
    {
      value: 1,
      name: getFormatMessage('puffer_apply_southeast'),
      RegionID: 7101,
      ClusterID: 702,
    },
    {
      value: 2,
      name: getFormatMessage('puffer_apply_japan'),
      RegionID: 7110,
      ClusterID: 710,
    },
    {
      value: 3,
      name: getFormatMessage('puffer_apply_korea'),
      RegionID: 7111,
      ClusterID: 711,
    },
    {
      value: 4,
      name: getFormatMessage('puffer_apply_europe'),
      RegionID: 7104,
      ClusterID: 705,
    },
    {
      value: 5,
      name: getFormatMessage('puffer_apply_eastern'),
      RegionID: 7108,
      ClusterID: 709,
    },
    {
      value: 6,
      name: getFormatMessage('puffer_apply_western'),
      RegionID: 7102,
      ClusterID: 703,
    },
    {
      value: 7,
      name: getFormatMessage('puffer_apply_south'),
      RegionID: 7103,
      ClusterID: 704,
    },
    {
      value: 8,
      name: getFormatMessage('puffer_apply_singapore'),
      RegionID: 7114,
      ClusterID: 714,
    },
  ];

  useEffect(() => {
    if (!props.selectedServiceConfig) return;
    let serviceItem =
      associatedServicesData[props.selectedServiceConfig.Name]?.services || [];
    const itemGos = JSON.parse(props.selectedEnv?.GosParams || '{}');
    if (props.selectedServiceConfig.Name === 'Matchmaking') {
      if (!isVersionGreaterThan(itemGos?.GameServiceVersion)) {
        serviceItem = [];
      }
    }
    if (props.selectedServiceConfig.Name === 'Battle') {
      if (
        !isVersionGreaterThan(itemGos?.GameServiceVersion) &&
        !serviceItem.includes('Matchmaking')
      ) {
        serviceItem.push('Matchmaking');
      }
    }

    if (props.selectedServerStatus) {
      let isOpenAllService = true;
      let closeService = false;
      if (serviceItem.length !== 0) {
        serviceItem.forEach((item) => {
          const subserviceItem = props.selectedServerStatus?.find((it) => {
            return (
              it.subserviceName === toLowerCaseAndRemoveSpaces(item) &&
              (it.stage === 'applying' || it.stage === 'opened')
            );
          });
          const closeServiceItem = props.selectedServerStatus?.find((it) => {
            return (
              it.subserviceName === toLowerCaseAndRemoveSpaces(item) &&
              it.stage === 'opened' &&
              it.status === 2
            );
          });
          if (closeServiceItem) {
            closeService = true;
          }
          if (!subserviceItem) {
            isOpenAllService = false;
          }
        });
      } else {
        const subserviceItem = props.selectedServerStatus?.find((it) => {
          return it.stage === 'applying' || it.stage === 'opened';
        });
        const closeServiceItem = props.selectedServerStatus?.find((it) => {
          return it.stage === 'opened' && it.status === 2;
        });
        if (closeServiceItem) {
          closeService = true;
        }
        if (!subserviceItem) {
          isOpenAllService = false;
        }
      }
      const openedServiceItem = props.selectedServerStatus?.find((it) => {
        // 只要有开通的服务，就不走关停逻辑
        return it.stage === 'opened' && it.status === 1;
      });
      if (openedServiceItem) {
        closeService = false;
      }
      setTemplateApplyAllStatus(isOpenAllService);
      setIsClose(closeService);
      return;
    }
    setTemplateApplyAllStatus(false);
    setIsClose(false);
  }, [props.selectedServiceConfig, props.selectedServerStatus]);

  useEffect(() => {
    getServiceApplyInfoList();
  }, []);

  const getServiceApplyInfoList = async () => {
    const res = await getServiceApplyInfo(props.selectedGameID);
    if (res) {
      setServiceApplyInfo(res);
      initDmp(res);
    }
  };

  const initDmp = (applyInfo: IServiceApplyInfo[]) => {
    if (
      props.selectedServiceConfig?.Name === 'Dynamic Update' ||
      props.selectedServiceConfig?.Name === 'Launch Update'
    ) {
      const configDynamicItem = allServiceConfig?.find(
        (item) => item.Name === 'Dynamic Update'
      );
      const configLaunchItem = allServiceConfig?.find(
        (item) => item.Name === 'Launch Update'
      );
      const applyInfoItem = applyInfo.find((item) => {
        const applyInfoData = JSON.parse(item.ApplyInfo || '[{}]');
        return (
          (item.ServiceID === configDynamicItem?.id ||
            item.ServiceID === configLaunchItem?.id) &&
          applyInfoData?.length !== 0
        );
      });
      const applyInfoData = JSON.parse(applyInfoItem?.ApplyInfo || '[{}]');
      const currentRegion: number[] = [];
      if (!isSingapore) {
        setPufferQpsNum(applyInfoData[0]?.QPS);
      } else {
        const currentApplyInfo: {
          [key: number]: number | null;
        } = {};
        applyInfoData.forEach((item: any) => {
          const regionItem = serviceRegion.find(
            (it) => it.RegionID === item.RegionID
          );
          if (regionItem) {
            currentApplyInfo[regionItem.value] = item.QPS;
            currentRegion.push(regionItem.value);
          }
        });
        setRegionValues(currentApplyInfo);
        setSelectRegion(currentRegion);
      }
    }
  };

  useEffect(() => {
    if (getIsNeedInfo(props.selectedServiceConfig?.Name || '')) {
      setIsNeedInfo(true);
    }
    const currentServiceInfo = findServiceInfo(
      props.selectedServiceConfig?.Name || ''
    );
    setServiceInfo(currentServiceInfo);

    if (isClose) {
      return setSelectServices([]);
    }
    // 初始化选中未开通的所有子服务
    const currentSelectService: string[] = [];
    if (currentServiceInfo && currentServiceInfo.services.length !== 0) {
      currentServiceInfo.services.forEach((item) => {
        const openService = props.selectedServerStatus?.find((it) => {
          if (item === 'DS') {
            return (
              it.subserviceName === toLowerCaseAndRemoveSpaces(item) ||
              it.subserviceName === toLowerCaseAndRemoveSpaces('Build') ||
              it.subserviceName === toLowerCaseAndRemoveSpaces('Fleet') ||
              it.subserviceName === toLowerCaseAndRemoveSpaces('Logs')
            );
          }
          return it.subserviceName === toLowerCaseAndRemoveSpaces(item);
        });
        if (!openService) {
          currentSelectService.push(toLowerCaseAndRemoveSpaces(item));
        }
      });
      setSelectServices(currentSelectService);
    }
  }, [isClose]);

  useEffect(() => {
    if (selectServices.includes('playertable')) {
      const playerService = allServiceConfig?.find(
        (item) => item.Name === 'Player'
      );
      if (playerService?.id) {
        const playerItem = props.allServicesStatus[playerService?.id] || [];
        let needInfo = true;
        playerItem.forEach((item) => {
          if (item.stage === 'applying' || item.stage === 'opened') {
            needInfo = false;
          }
        });
        setIsNeedInfo(needInfo);
      }
    }
    if (
      !selectServices.includes('playertable') &&
      !getIsNeedInfo(props.selectedServiceConfig?.Name || '')
    ) {
      setIsNeedInfo(false);
    }
  }, [selectServices]);

  const onClose = () => {
    props.onClose();
    setSelectServices([]);
    setStep(ApplyStep.Confirm);
    setPufferQpsNum(null);
  };

  const findServiceInfo = (name: string) => {
    if (associatedServicesData[name]) {
      if (name === 'Matchmaking') {
        const itemGos = JSON.parse(props.selectedEnv?.GosParams || '{}');
        // 旧版本Matchmaking不要子服务
        if (!isVersionGreaterThan(itemGos?.GameServiceVersion)) {
          return null;
        }
      }
      return associatedServicesData[name];
    }
    return null;
  };

  const toLowerCaseAndRemoveSpaces = (str: string) => {
    return str.toLowerCase().replace(/\s+/g, '');
  };

  const getRelevance = (str: string) => {
    const relevanceName = str.split('/') || [];
    if (relevanceName.length > 1) {
      return relevanceName[relevanceName.length - 1].trim();
    }
    return relevanceName[0].trim();
  };

  const onServicesChange = (checkedValues: any[]) => {
    setSelectServices(checkedValues);
  };

  const getIsNeedInfo = (name: string) => {
    const playerItem = servicesConfig?.find((item) => item.Name === 'Player');
    let playerIsOpen = false;
    if (playerItem) {
      const playerStatus = props.allServicesStatus[playerItem.id];
      const statusOpened = playerStatus?.find(
        (item) => item.stage === 'opened' || item.stage === 'applying'
      );
      if (statusOpened) {
        playerIsOpen = true;
      }
    }

    return (
      name === 'Player' ||
      name === 'Friends' ||
      name === 'Dynamic Update' ||
      name === 'Launch Update' ||
      (name === 'Notifications' && !playerIsOpen)
    );
  };

  const getIsVoiceService = () => {
    return (
      isFeeEnable() &&
      props.selectedEnv?.Type === GameEnvType.Live &&
      /^voice\s+chat$/i.test(props.selectedServiceConfig?.Name || '')
    );
  };

  // const getCurrentServiceSubName = () => {
  //   if (props.selectedServiceConfig?.Name === 'DS Hosting') {
  //     const currentServices: string[] = [];
  //     if (!props.selectedServerStatus) {
  //       serviceInfo?.services.forEach((item) => {
  //         currentServices.push(toLowerCaseAndRemoveSpaces(item));
  //       });
  //       return currentServices;
  //     }
  //     serviceInfo?.services.forEach((item) => {
  //       const serverStatusItem = props.selectedServerStatus?.find(
  //         (it) =>
  //           it.subserviceName === toLowerCaseAndRemoveSpaces(item) &&
  //           (it.stage === 'applying' || it.stage === 'opened')
  //       );
  //       if (!serverStatusItem) {
  //         currentServices.push(toLowerCaseAndRemoveSpaces(item));
  //       }
  //     });
  //     return currentServices;
  //   }
  //   return selectServices;
  // };

  const jumpToOrderPage = (orderID: string) => {
    if (!selectStudio) {
      return;
    }

    history.push(
      `/studio/${selectStudio.studioID}/fee/order-result/${orderID}`
    );
  };

  const applyOpen = async (isConfirm: boolean): Promise<boolean> => {
    const isVoiceService = getIsVoiceService();

    if (step === ApplyStep.Confirm) {
      if (isNeedInfo) {
        setStep(ApplyStep.FillInfo);
        return false;
      }
      if (isVoiceService) {
        setStep(ApplyStep.Shop);
        return false;
      }
    }
    auditApplyServiceWriteLog(props.selectedServiceConfig?.Name, {
      gameID: props.selectedGameID,
      envID: props.selectedEnv?.Guid || '',
      envType: props.selectedEnv?.Type,
    });
    let envIdParams;
    if (props.selectedEnv && props.selectedServiceConfig && !isConfirm) {
      envIdParams = props.selectedEnv.id;
      if (props.selectedServiceConfig.Business === ServiceBusiness.DMP) {
        const keyList = Object.keys(props.serviceAllEnvStatus) || [];
        let devOpen = false;
        let liveOpen = false;
        const openList: string[] = [];
        keyList.forEach((keyItem) => {
          const envStatusItem = props.serviceAllEnvStatus[keyItem];
          if (envStatusItem && envStatusItem.length !== 0) {
            const closeItem = envStatusItem.find(
              (statusItem) =>
                statusItem.stage === 'opened' && statusItem.status === 2
            );
            if (!closeItem) {
              envStatusItem.forEach((statusItem) => {
                if (
                  statusItem.stage === 'opened' &&
                  openList.indexOf(keyItem) === -1
                ) {
                  openList.push(keyItem);
                }
              });
            }
          }
        });
        openList.forEach((openItem) => {
          const envItem = allEnvList.find(
            (item) => item.envIncrementID === Number(openItem)
          );
          if (envItem?.envType === GameEnvType.Dev) {
            devOpen = true;
          }
          if (envItem?.envType === GameEnvType.Live) {
            liveOpen = true;
          }
        });
        if (
          !devOpen &&
          !liveOpen &&
          props.selectedEnv.Type === GameEnvType.Live
        ) {
          const envItem = allEnvList.find((item) => {
            const itemStatus = props.serviceAllEnvStatus[item.envIncrementID];
            let itemClose;
            if (itemStatus && itemStatus.length !== 0) {
              itemClose = itemStatus.find(
                (it) => it.stage === 'opened' && it.status === 2
              );
            }
            return (
              item.gameID === props.selectedGameID &&
              item.envType === GameEnvType.Dev &&
              !itemClose
            );
          });
          if (envItem) {
            envIdParams = envItem.envIncrementID;
          }
        }
        if (
          devOpen &&
          !liveOpen &&
          props.selectedEnv.Type === GameEnvType.Live
        ) {
          setShowConfirmDmp(true);
          return false;
        }
        if (liveOpen && props.selectedEnv.Type === GameEnvType.Dev) {
          let service = '';
          if (props.selectedServiceConfig?.Name === 'Dynamic Update') {
            service = 'puffer';
          } else if (props.selectedServiceConfig?.Name === 'Launch Update') {
            service = 'dolphin';
          }
          messageError(
            getFormatMessage('dmp_nonsupport_open_dev', {
              params: {
                service,
              },
            })
          );
          return false;
        }
      }
    }

    const values = await infoForm.validateFields();
    setLoading(true);
    if (props.selectedServiceConfig) {
      const serviceId = props.selectedServiceConfig.id;
      try {
        if (props.selectedEnv?.id) {
          const relevance: string[] = Object.assign(
            [],
            serviceInfo?.relevance || []
          );
          const newValues: IQPSItem[] = [];
          if (
            props.selectedServiceConfig?.Name === 'Dynamic Update' ||
            props.selectedServiceConfig?.Name === 'Launch Update'
          ) {
            if (isEnvProd || isEnvPre) {
              if (isSingapore) {
                selectRegion.forEach((item) => {
                  const regionItem = serviceRegion.find(
                    (it) => it.value === item
                  );
                  const qpsItem = regionValues[item];
                  if (regionItem && qpsItem) {
                    newValues.push({
                      QPS: qpsItem,
                      RegionID: regionItem.RegionID,
                      ClusterID: regionItem.ClusterID,
                    });
                  }
                });
              }
              if (isWoa) {
                newValues.push({
                  QPS: values.QPS,
                  RegionID: 2100,
                  ClusterID: 200,
                });
              }
              if (isCn) {
                newValues.push({
                  QPS: values.QPS,
                  RegionID: 4100,
                  ClusterID: 410,
                });
              }
            } else {
              newValues.push({
                QPS: values.QPS,
                RegionID: 20001,
                ClusterID: 1,
              });
            }
          }
          const serviceItems = {
            [serviceId]: {
              serviceID: serviceId,
              // subName: getCurrentServiceSubName(),
              subName: selectServices,
              applyInfo:
                getIsNeedInfo(props.selectedServiceConfig.Name) &&
                props.selectedServiceConfig.Name !== 'Notifications'
                  ? JSON.stringify(newValues.length !== 0 ? newValues : values)
                  : '',
              isRelation: false,
            },
          };
          if (props.selectedServiceConfig?.Name === 'Custom Data') {
            selectServices.forEach((item) => {
              // selectServices存值小写去空格 relevance展示需要用服务大写名称
              if (item.indexOf('player') !== -1) {
                relevance.push('Player');
              }
              if (item.indexOf('party') !== -1) {
                relevance.push('Battle / Party');
                if (!relevance.includes('Token')) {
                  relevance.push('Token');
                }
              }
              if (item.indexOf('lobby') !== -1) {
                relevance.push('Battle / Lobby');
                if (!relevance.includes('Token')) {
                  relevance.push('Token');
                }
              }
              if (item.indexOf('guild') !== -1) {
                relevance.push('Guild');
              }
            });
          }
          if (props.selectedServiceConfig?.Name === 'Battle') {
            if (
              selectServices.includes('party') ||
              selectServices.includes('lobby')
            ) {
              relevance.push('Token');
              const itemGos = JSON.parse(props.selectedEnv?.GosParams || '{}');
              // 大于1.12.0版本Matchmaking才有FactionSet子服务
              if (isVersionGreaterThan(itemGos?.GameServiceVersion)) {
                relevance.push('Matchmaking / FactionSet');
              }
            }
          }
          if (props.selectedServiceConfig?.Name === 'Auto-Task') {
            selectServices.forEach((item) => {
              // selectServices存值小写去空格 relevance展示需要用服务大写名称
              if (item.indexOf('battlepass') !== -1) {
                relevance.push('Statistics');
              }
            });
          }
          if (props.selectedServiceConfig?.Name === 'Matchmaking') {
            relevance.push('DS Hosting / Gamemode');
            relevance.push('Battle / Custom Tags');
          }
          const newRelevance: string[] = [];
          relevance.forEach((item) => {
            if (!newRelevance.includes(item)) {
              newRelevance.push(item);
            }
          });
          newRelevance.forEach((item) => {
            const relevanceParent = item.split('/')[0].trim() || '';
            const relevanceItem = getRelevance(item);
            const parentItem = allServiceConfig?.find(
              (ServiceItem) => ServiceItem.Name === relevanceParent
            );
            if (parentItem) {
              const serviceStatusItem = props.allServicesStatus[parentItem?.id];
              let isOpen = false;
              if (serviceStatusItem) {
                // relevanceItem === relevanceParent 代表是父服务
                // 父服务判断是否开通
                if (relevanceItem === relevanceParent) {
                  serviceStatusItem.forEach((it) => {
                    if (
                      !it.subserviceName &&
                      (it.stage === 'applying' || it.stage === 'opened')
                    ) {
                      isOpen = true;
                    }
                  });
                } else {
                  // 子服务判断是否开通
                  serviceStatusItem.forEach((it) => {
                    if (
                      it.subserviceName ===
                        toLowerCaseAndRemoveSpaces(relevanceItem) &&
                      (it.stage === 'applying' || it.stage === 'opened')
                    ) {
                      isOpen = true;
                    }
                  });
                }
              }
              if (isOpen) {
                return;
              }
              serviceItems[parentItem.id] = {
                serviceID: parentItem.id,
                subName:
                  relevanceItem === relevanceParent
                    ? []
                    : [toLowerCaseAndRemoveSpaces(relevanceItem)],
                applyInfo:
                  relevanceItem === relevanceParent &&
                  getIsNeedInfo(relevanceItem)
                    ? JSON.stringify(
                        newValues.length !== 0 ? newValues : values
                      )
                    : '',
                isRelation: true,
              };
            }
          });
          const applyBody = {
            serviceItems,
            toLink: `${location.origin}/admin/service`,
            gameID: props.selectedGameID,
            envID: envIdParams || props.selectedEnv.id,
            applyTime: getUtcTime(new Date()),
          };
          const res: any = await applyService(applyBody);
          let repetitionServices = '';
          switch (res.code) {
            case CodeServices.CurrentServiceApproval:
              props.onOk(true);
              if (res.data?.applying && res.data.applying.length !== 0) {
                res.data.applying.forEach((item: any) => {
                  if (item.SubServiceName) {
                    if (repetitionServices.length === 0) {
                      repetitionServices += item.SubServiceName;
                    } else {
                      repetitionServices += `,${item.SubServiceName}`;
                    }
                  }
                });
              }
              messageWarning(
                getFormatMessage('application_already_sent', {
                  params: {
                    services: repetitionServices,
                  },
                })
              );
              break;
            case CodeServices.UserApplyOpenedServiceNotFound:
              messageWarning(getFormatMessage('service_not_exist'));
              break;
            case CodeServices.NotExistToApprovalURL:
              messageError(getFormatMessage('apply_service_fail'));
              break;
            case CodeServices.CompanyAuthNotComplete:
              messageWarning(getFormatMessage('company_not_valid'));
              break;
            default:
              messageSuccess(getFormatMessage('application_sent_success'));
              props.onOk(true);
              if (isVoiceService) {
                jumpToOrderPage(res.data?.[0]);
                return true;
              }
              setStep(ApplyStep.Submit);
          }
          if (serviceId === -1) {
            setLoading(false);
            onClose();
            return false;
          }
        } else {
          messageError(getFormatMessage('please_select_the_env'));
        }
      } catch (err: any) {
        if (err?.apiError?.code === 101803) {
          messageSuccess(getFormatMessage('application_sent_success'));
          props.onOk(true);
        } else if (err?.apiError?.code === 101846) {
          messageError(getFormatMessage('company_status_error_warn'));
        } else {
          messageError(getFormatMessage('apply_service_fail'));
        }
      }
      setLoading(false);
      // onClose();
      return true;
    }
    return true;
  };

  if (!jsonConfig) {
    return null;
  }

  const configItems = jsonConfig[currentStoreLanguage];

  const renderServices = () => {
    const servicesOptions: {
      label: string;
      value: string;
      disabled: boolean;
    }[] = [];
    if (serviceInfo && serviceInfo.services.length !== 0) {
      serviceInfo.services.forEach((item) => {
        const openService = props.selectedServerStatus?.find(
          (it) => it.subserviceName === toLowerCaseAndRemoveSpaces(item)
        );
        let isDisabled = false;
        if (props.selectedServiceConfig?.Name === 'Battle') {
          if (toLowerCaseAndRemoveSpaces(item) === 'customtags') {
            isDisabled = true;
          }
        }
        if (props.selectedServiceConfig?.Name === 'DS Hosting') {
          if (toLowerCaseAndRemoveSpaces(item) === 'gamemode') {
            isDisabled = true;
          }
        }
        servicesOptions.push({
          label: item,
          value: toLowerCaseAndRemoveSpaces(item),
          disabled:
            !!openService ||
            isClose ||
            props.selectedServiceConfig?.Name === 'Matchmaking' ||
            isDisabled,
        });
      });
      return (
        <div style={{ marginTop: '32px' }}>
          <Checkbox.Group
            options={servicesOptions}
            onChange={onServicesChange}
            value={selectServices}
          />
          <div
            style={{
              marginTop: '8px',
              color: '#FF6135',
              fontWeight: 400,
              fontSize: '12px',
            }}
          >
            <img
              src={warnImage}
              alt="Warning"
              style={{
                width: '14px',
                height: '14px',
                marginRight: '8px',
                marginTop: '-2px',
              }}
            />
            <span>
              {props.selectedServiceConfig?.Name !== 'Matchmaking'
                ? getFormatMessage('please_select_open_service', {
                    params: {
                      service: props.selectedServiceConfig?.Name,
                    },
                  })
                : getFormatMessage('matchmaking_apply_tips')}
            </span>
          </div>
        </div>
      );
    }
    return null;
  };

  const renderRelevance = () => {
    const relevance = Object.assign([], serviceInfo?.relevance || []);
    if (props.selectedServiceConfig?.Name === 'Custom Data') {
      selectServices.forEach((item) => {
        // selectServices存值小写去空格 relevance展示需要用服务大写名称
        if (item.indexOf('player') !== -1) {
          // const playerService = allServiceConfig?.find(item => item.Name === 'Player');
          // if (playerService?.id) {
          //   const playerItem = props.allServicesStatus[playerService?.id] || [];
          //   let needShow = true;
          //   playerItem.forEach(item => {
          //     if (item.stage === 'applying' || item.stage === 'opened') {
          //       needShow = false;
          //     }
          //   });
          //   if (needShow) {
          //     relevance.push('Player');
          //   }
          // }
          relevance.push('Player');
        }
        if (item.indexOf('party') !== -1) {
          relevance.push('Battle / Party');
          relevance.push('Token');
        }
        if (item.indexOf('lobby') !== -1) {
          relevance.push('Battle / Lobby');
          relevance.push('Token');
        }
        if (item.indexOf('guild') !== -1) {
          relevance.push('Guild');
        }
      });
    }
    if (props.selectedServiceConfig?.Name === 'Battle') {
      selectServices.forEach((item) => {
        if (item.indexOf('party') !== -1 || item.indexOf('lobby') !== -1) {
          relevance.push('Token');
          const itemGos = JSON.parse(props.selectedEnv?.GosParams || '{}');
          // 大于1.12.0版本Matchmaking才有FactionSet子服务
          if (isVersionGreaterThan(itemGos?.GameServiceVersion)) {
            relevance.push('Matchmaking / FactionSet');
          }
        }
      });
    }
    if (props.selectedServiceConfig?.Name === 'Auto-Task') {
      selectServices.forEach((item) => {
        // selectServices存值小写去空格 relevance展示需要用服务大写名称
        if (item.indexOf('battlepass') !== -1) {
          relevance.push('Statistics');
        }
      });
    }
    if (props.selectedServiceConfig?.Name === 'Matchmaking') {
      relevance.push('DS Hosting / Gamemode');
      relevance.push('Battle / Custom Tags');
    }
    const newRelevance: string[] = [];
    relevance.forEach((item) => {
      if (!newRelevance.includes(item)) {
        newRelevance.push(item);
      }
    });
    if (newRelevance.length !== 0) {
      return (
        <div className="relevance-box">
          {newRelevance.map((item, index) => {
            const relevanceName = getRelevance(item);
            const relevanceParent = item.split('/')[0].trim() || '';
            const parentItem = allServiceConfig?.find(
              (ServiceItem) => ServiceItem.Name === relevanceParent
            );
            let selectService = props.selectedServiceConfig?.Name;
            if (props.selectedServiceConfig?.Name === 'Custom Data') {
              if (relevanceName === 'Player') {
                selectService += ' / Player Table';
              } else if (relevanceName === 'Party') {
                selectService += ' / Party Table';
              } else if (relevanceName === 'Lobby') {
                selectService += ' / Lobby Table';
              } else if (relevanceName === 'Guild') {
                selectService += ' / Guild Table';
              }
            }
            if (
              props.selectedServiceConfig?.Name === 'Custom Data' ||
              props.selectedServiceConfig?.Name === 'Battle'
            ) {
              if (relevanceName === 'Token' || relevanceName === 'FactionSet') {
                selectService = 'Party & Lobby';
              }
            }
            let relevanceDesc = '';
            if (!parentItem) {
              return null;
            }
            if (relevanceName === 'Gamemode') {
              relevanceDesc = getFormatMessage('gamemode_desc');
            } else if (relevanceName === 'Party') {
              relevanceDesc = getFormatMessage('party_desc');
            } else if (relevanceName === 'Lobby') {
              relevanceDesc = getFormatMessage('lobby_desc');
            } else if (relevanceName === 'CustomTag') {
              relevanceDesc = getFormatMessage('customtag_desc');
            } else {
              if (parentItem) {
                const relevanceJson = strToJson<IServiceApplyConfig>(
                  parentItem.JsonConfig || ''
                );
                if (relevanceJson) {
                  const configItems = relevanceJson[currentStoreLanguage];
                  relevanceDesc = configItems?.description || '';
                }
              }
            }
            return (
              <div className="relevance-item-box">
                <div className="relevance-item-top-line"></div>
                <div
                  className={classNames(
                    'relevance-item-bottom-line',
                    index === newRelevance.length - 1 ? 'white-line' : ''
                  )}
                ></div>
                <div className="relevance-item">
                  <div className="relevance-title">
                    <span className="relevance-title-left">{item}</span>
                    <span className="relevance-title-right">
                      {parentItem.ParentName}
                    </span>
                  </div>
                  <div className="relevance-desc">{relevanceDesc}</div>
                  <div
                    style={{
                      marginTop: '9px',
                      color: '#FF6135',
                      fontWeight: 400,
                      fontSize: '12px',
                    }}
                  >
                    <img
                      src={warnImage}
                      alt="Warning"
                      style={{
                        width: '14px',
                        height: '14px',
                        marginRight: '8px',
                        marginTop: '-2px',
                      }}
                    />
                    <span>
                      {getFormatMessage('automatically_open_service', {
                        params: {
                          service: selectService,
                          relevanceService: item,
                        },
                      })}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      );
    }
    return null;
  };

  const getOkText = () => {
    if (step === ApplyStep.Confirm) {
      if (isNeedInfo) {
        return getFormatMessage('apply_next_btn');
      }
      if (getIsVoiceService()) {
        return getFormatMessage('apply_next_btn');
      }
    }

    if (step === ApplyStep.Shop) {
      return getFormatMessage('service_apply_estimate');
    }

    if (step === ApplyStep.Submit) {
      return '';
    }

    return getFormatMessage('apply_submit_btn');
  };

  const onBack = () => {
    setStep(ApplyStep.Confirm);
  };

  const renderServicesConfirm = () => {
    if (step === ApplyStep.Confirm) {
      return (
        <div className="services-scroll-box">
          <div className="services-show-box">
            <div className="services-title">
              <span className="services-title-left">
                {props.selectedServiceConfig?.Name}
              </span>
              <span className="services-title-right">
                {props.selectedServiceConfig?.ParentName}
              </span>
            </div>
            <div className="services-desc">
              {configItems?.description || ''}
            </div>
            {renderServices()}
            {props.selectedServiceConfig?.Name === 'Command' && (
              <div
                style={{
                  marginTop: '12px',
                  color: '#FF6135',
                  fontWeight: 400,
                  fontSize: '12px',
                }}
              >
                <img
                  src={warnImage}
                  alt="Warning"
                  style={{
                    width: '14px',
                    height: '14px',
                    marginRight: '8px',
                    marginTop: '-2px',
                  }}
                />
                <span>{getFormatMessage('ingame_operation_tips')}</span>
              </div>
            )}
          </div>
          {renderRelevance()}
        </div>
      );
    }
    return null;
  };

  const getFormInit = () => {
    if (
      props.selectedServiceConfig?.Name === 'Dynamic Update' ||
      props.selectedServiceConfig?.Name === 'Launch Update'
    ) {
      const configDynamicItem = allServiceConfig?.find(
        (item) => item.Name === 'Dynamic Update'
      );
      const configLaunchItem = allServiceConfig?.find(
        (item) => item.Name === 'Launch Update'
      );
      const applyInfoItem = serviceApplyInfo.find((item) => {
        const applyInfoData = JSON.parse(item.ApplyInfo || '[{}]');
        return (
          (item.ServiceID === configDynamicItem?.id ||
            item.ServiceID === configLaunchItem?.id) &&
          applyInfoData?.length !== 0
        );
      });
      const applyInfoData = JSON.parse(applyInfoItem?.ApplyInfo || '[{}]');
      const currentRegion: number[] = [];
      applyInfoData.forEach((item: any) => {
        const regionItem = serviceRegion.find(
          (it) => it.RegionID === item.RegionID
        );
        if (regionItem) {
          currentRegion.push(regionItem.value);
        }
      });
      if (applyInfoData) {
        if (!isSingapore) {
          return {
            QPS: applyInfoData[0].QPS || 1,
          };
        }
        return {
          Region: currentRegion,
        };
      }
    }
    const applyInfoItem = serviceApplyInfo.find((item) => {
      const applyInfoData = JSON.parse(item.ApplyInfo || '{}');
      return (
        item.ServiceID === props.selectedServiceConfig?.id &&
        Object.keys(applyInfoData).length !== 0
      );
    });
    const applyInfoData = JSON.parse(applyInfoItem?.ApplyInfo || '{}');
    if (
      props.selectedServiceConfig?.Name === 'Player' ||
      selectServices.includes('playertable') ||
      props.selectedServiceConfig?.Name === 'Notifications'
    ) {
      return {
        whether_name_unique: applyInfoData.whether_name_unique || 1,
        whether_query_by_name: applyInfoData.whether_query_by_name || 1,
      };
    }
    if (props.selectedServiceConfig?.Name === 'Friends') {
      return {
        friend_type: applyInfoData.friend_type || 1,
      };
    }
  };

  const onRegionChange = (checkedValues: any) => {
    setSelectRegion(checkedValues);
    // 去除取消选中的地区值
    const newRegionValues: { [key: number]: number | null } = {};
    checkedValues.forEach((item: number) => {
      newRegionValues[item] = regionValues[item];
    });
    setRegionValues(newRegionValues);
  };

  const onQpsChange = (value: number | null, region: number) => {
    setRegionValues((prevValues) => ({
      ...prevValues,
      [region]: value,
    }));
  };

  const getIsApplyInfoDisabled = () => {
    let isDisabled = false;
    if (
      props.selectedServiceConfig?.Name === 'Dynamic Update' ||
      props.selectedServiceConfig?.Name === 'Launch Update'
    ) {
      const configDynamicItem = allServiceConfig?.find(
        (item) => item.Name === 'Dynamic Update'
      );
      const configLaunchItem = allServiceConfig?.find(
        (item) => item.Name === 'Launch Update'
      );
      const applyInfoItem = serviceApplyInfo.find((item) => {
        const applyInfoData = JSON.parse(item.ApplyInfo || '[{}]');
        return (
          (item.ServiceID === configDynamicItem?.id ||
            item.ServiceID === configLaunchItem?.id) &&
          applyInfoData.length !== 0
        );
      });
      if (applyInfoItem) {
        return (isDisabled = true);
      }
    } else {
      const applyInfoItem = serviceApplyInfo.find((item) => {
        const applyInfoData = JSON.parse(item.ApplyInfo || '{}');
        return (
          item.ServiceID === props.selectedServiceConfig?.id &&
          Object.keys(applyInfoData).length !== 0
        );
      });
      if (applyInfoItem) {
        return (isDisabled = true);
      }
    }
    return isDisabled;
  };

  const renderInformationFilling = () => {
    if (step === ApplyStep.FillInfo) {
      return (
        <Form
          form={infoForm}
          className="services-info-form"
          initialValues={getFormInit()}
        >
          {(props.selectedServiceConfig?.Name === 'Player' ||
            selectServices.includes('playertable') ||
            props.selectedServiceConfig?.Name === 'Notifications') && (
            <div>
              <Form.Item
                label={getFormatMessage('whether_name_unique_label')}
                name="whether_name_unique"
                colon={false}
              >
                <Radio.Group
                  defaultValue={1}
                  disabled={getIsApplyInfoDisabled()}
                >
                  <Space direction="vertical">
                    {getIsApplyInfoDisabled() ? (
                      <CustomPopover
                        content={getFormatMessage('no_re_submission_tips')}
                      >
                        <Radio value={1}>{getFormatMessage('yes')}</Radio>
                      </CustomPopover>
                    ) : (
                      <Radio value={1}>{getFormatMessage('yes')}</Radio>
                    )}
                    {getIsApplyInfoDisabled() ? (
                      <CustomPopover
                        content={getFormatMessage('no_re_submission_tips')}
                      >
                        <Radio value={-1}>{getFormatMessage('no')}</Radio>
                      </CustomPopover>
                    ) : (
                      <Radio value={-1}>{getFormatMessage('no')}</Radio>
                    )}
                  </Space>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                label={getFormatMessage('whether_query_by_name_label')}
                name="whether_query_by_name"
                colon={false}
              >
                <Radio.Group
                  defaultValue={1}
                  disabled={getIsApplyInfoDisabled()}
                >
                  <Space direction="vertical">
                    {getIsApplyInfoDisabled() ? (
                      <CustomPopover
                        content={getFormatMessage('no_re_submission_tips')}
                      >
                        <Radio value={1}>{getFormatMessage('yes')}</Radio>
                      </CustomPopover>
                    ) : (
                      <Radio value={1}>{getFormatMessage('yes')}</Radio>
                    )}
                    {getIsApplyInfoDisabled() ? (
                      <CustomPopover
                        content={getFormatMessage('no_re_submission_tips')}
                      >
                        <Radio value={-1}>{getFormatMessage('no')}</Radio>
                      </CustomPopover>
                    ) : (
                      <Radio value={-1}>{getFormatMessage('no')}</Radio>
                    )}
                  </Space>
                </Radio.Group>
              </Form.Item>
            </div>
          )}
          {props.selectedServiceConfig?.Name === 'Friends' && (
            <Form.Item
              label={getFormatMessage('friend_type_label')}
              name="friend_type"
              colon={false}
            >
              <Radio.Group defaultValue={1} disabled={getIsApplyInfoDisabled()}>
                <Space direction="vertical">
                  {getIsApplyInfoDisabled() ? (
                    <CustomPopover
                      content={getFormatMessage('no_re_submission_tips')}
                    >
                      <Radio value={1}>
                        {getFormatMessage('account_friends')}
                      </Radio>
                    </CustomPopover>
                  ) : (
                    <Radio value={1}>
                      {getFormatMessage('account_friends')}
                    </Radio>
                  )}
                  {getIsApplyInfoDisabled() ? (
                    <CustomPopover
                      content={getFormatMessage('no_re_submission_tips')}
                    >
                      <Radio value={2}>
                        {getFormatMessage('character_friends')}
                      </Radio>
                    </CustomPopover>
                  ) : (
                    <Radio value={2}>
                      {getFormatMessage('character_friends')}
                    </Radio>
                  )}
                </Space>
              </Radio.Group>
            </Form.Item>
          )}
          {(props.selectedServiceConfig?.Name === 'Dynamic Update' ||
            props.selectedServiceConfig?.Name === 'Launch Update') && (
            <div>
              {isSingapore && (isEnvProd || isEnvPre) ? (
                <Form.Item
                  label={getFormatMessage('puffer_apply_region')}
                  name="Region"
                >
                  {getIsApplyInfoDisabled() ? (
                    <CustomPopover
                      content={getFormatMessage('no_re_submission_tips')}
                    >
                      <Checkbox.Group
                        onChange={onRegionChange}
                        disabled={getIsApplyInfoDisabled()}
                      >
                        <Space direction="vertical">
                          {serviceRegion.map((item) => {
                            return (
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  lineHeight: '30px',
                                }}
                              >
                                <Checkbox value={item.value}>
                                  {item.name}
                                </Checkbox>
                                {selectRegion.includes(item.value) && (
                                  <InputNumber
                                    width={300}
                                    min={1}
                                    precision={0}
                                    formatter={(value) => {
                                      let newVal = value;
                                      if (value && value < 1) {
                                        newVal = 1;
                                      }
                                      return `${newVal}`.replace(/\D/g, '');
                                    }}
                                    value={regionValues[item.value]}
                                    // onChange={(value) => setPufferQpsNum(value)}
                                    placeholder={getFormatMessage(
                                      'qps_placeholder'
                                    )}
                                    onChange={(value) =>
                                      onQpsChange(value, item.value)
                                    }
                                    disabled={getIsApplyInfoDisabled()}
                                  />
                                )}
                              </div>
                            );
                          })}
                        </Space>
                      </Checkbox.Group>
                    </CustomPopover>
                  ) : (
                    <Checkbox.Group
                      onChange={onRegionChange}
                      disabled={getIsApplyInfoDisabled()}
                    >
                      <Space direction="vertical">
                        {serviceRegion.map((item) => {
                          return (
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                lineHeight: '30px',
                              }}
                            >
                              <Checkbox value={item.value}>
                                {item.name}
                              </Checkbox>
                              {selectRegion.includes(item.value) && (
                                <InputNumber
                                  width={300}
                                  min={1}
                                  precision={0}
                                  formatter={(value) => {
                                    let newVal = value;
                                    if (value && value < 1) {
                                      newVal = 1;
                                    }
                                    return `${newVal}`.replace(/\D/g, '');
                                  }}
                                  value={regionValues[item.value]}
                                  // onChange={(value) => setPufferQpsNum(value)}
                                  placeholder={getFormatMessage(
                                    'qps_placeholder'
                                  )}
                                  onChange={(value) =>
                                    onQpsChange(value, item.value)
                                  }
                                  disabled={getIsApplyInfoDisabled()}
                                />
                              )}
                            </div>
                          );
                        })}
                      </Space>
                    </Checkbox.Group>
                  )}
                </Form.Item>
              ) : (
                <Form.Item
                  label={getFormatMessage('qps_label')}
                  name="QPS"
                  // colon={false}
                >
                  {getIsApplyInfoDisabled() ? (
                    <CustomPopover
                      content={getFormatMessage('no_re_submission_tips')}
                    >
                      <div style={{ width: 350 }}>
                        <InputNumber
                          min={1}
                          precision={0}
                          formatter={(value) => {
                            let newVal = value;
                            if (value && value < 1) {
                              newVal = 1;
                            }
                            return `${newVal}`.replace(/\D/g, '');
                          }}
                          value={pufferQpsNum}
                          placeholder={getFormatMessage('qps_placeholder')}
                          disabled
                        />
                      </div>
                    </CustomPopover>
                  ) : (
                    <InputNumber
                      min={1}
                      precision={0}
                      formatter={(value) => {
                        let newVal = value;
                        if (value && value < 1) {
                          newVal = 1;
                        }
                        return `${newVal}`.replace(/\D/g, '');
                      }}
                      onChange={(value) => setPufferQpsNum(value)}
                      placeholder={getFormatMessage('qps_placeholder')}
                    />
                  )}
                </Form.Item>
              )}
            </div>
          )}
        </Form>
      );
    }
    return null;
  };

  const renderShop = () => {
    if (step === ApplyStep.Shop) {
      return <ServiceShop />;
    }
    return null;
  };

  const renderSecondStep = () => {
    if (isNeedInfo) {
      return (
        <>
          <div className="step-line"></div>{' '}
          <div
            className={classNames(
              'step-item',
              step === ApplyStep.FillInfo ? 'step-item-active' : ''
            )}
          >
            <span className="step-item-num">2</span>
            <span className="step-item-title">
              {getFormatMessage('information_filling')}
            </span>
          </div>
        </>
      );
    }
    const isVoiceService = getIsVoiceService();
    if (isVoiceService) {
      return (
        <>
          <div className="step-line"></div>
          <div
            className={classNames(
              'step-item',
              [ApplyStep.Shop].includes(step) ? 'step-item-active' : ''
            )}
          >
            <span className="step-item-num">{2}</span>
            <span className="step-item-title">
              {getFormatMessage('service_shop')}
            </span>
          </div>
        </>
      );
    }
    return <></>;
  };

  const renderSubmitStep = () => {
    const isVoiceService = getIsVoiceService();
    const isThreeStep = isNeedInfo || isVoiceService;

    return (
      <>
        <div className="step-line"></div>
        <div className="step-item">
          <span className="step-item-num">{isThreeStep ? 3 : 2}</span>
          <span className="step-item-title">
            {getIsVoiceService()
              ? getFormatMessage('service_apply_estimate')
              : getFormatMessage('submit_applications')}
          </span>
        </div>
      </>
    );
  };

  const getCancelText = () => {
    if (step === ApplyStep.Shop || step === ApplyStep.FillInfo) {
      return getFormatMessage('apply_back_btn');
    }
    return '';
  };

  const getOkTooltip = () => {
    if (isClose) {
      return getFormatMessage('service_close_tips');
    }
    if (templateApplyAllStatus) {
      return getFormatMessage('application_success');
    }
    return '';
  };

  const getPufferDisabled = () => {
    if (
      props.selectedServiceConfig?.Name === 'Dynamic Update' ||
      props.selectedServiceConfig?.Name === 'Launch Update'
    ) {
      if (isSingapore && (isEnvProd || isEnvPre)) {
        let isDisabled = false;
        if (step === ApplyStep.FillInfo) {
          if (selectRegion.length === 0) {
            isDisabled = true;
          }
          selectRegion.forEach((item) => {
            if (!regionValues[item]) {
              isDisabled = true;
            }
          });
        }
        return isDisabled;
      }
      if (!pufferQpsNum && step === ApplyStep.FillInfo) {
        return true;
      }
    }
    return false;
  };

  const renderConfirmDmp = () => {
    if (!showConfirmDmp) {
      return null;
    }
    let service = '';
    if (props.selectedServiceConfig?.Name === 'Dynamic Update') {
      service = 'puffer';
    } else if (props.selectedServiceConfig?.Name === 'Launch Update') {
      service = 'dolphin';
    }
    return (
      <ModalWrap
        oKText={getFormatMessage('confirm')}
        onClose={() => setShowConfirmDmp(false)}
        onOk={() => applyOpen(true)}
        cancelText={getFormatMessage('cancel')}
      >
        <div>
          {getFormatMessage('dmp_confirm_open_live', {
            params: {
              service,
            },
          })}
        </div>
      </ModalWrap>
    );
  };

  return (
    <div>
      <ModalWrap
        width="800px"
        loading={loading}
        onOk={() => applyOpen(false)}
        cancelText={getCancelText()}
        oKText={getOkText()}
        onClose={onClose}
        okTooltip={getOkTooltip()}
        title={
          step !== ApplyStep.Submit
            ? getFormatMessage('apply_title', {
                params: {
                  service: props.selectedServiceConfig?.Name,
                },
              })
            : ''
        }
        className="services-apply-modal"
        onCancel={onBack}
        disabled={
          (serviceInfo?.services &&
            serviceInfo?.services.length !== 0 &&
            selectServices.length === 0) ||
          getPufferDisabled() ||
          isClose ||
          templateApplyAllStatus
        }
      >
        <div className="services-apply">
          {step !== ApplyStep.Submit ? (
            <div>
              <div className="step-box">
                <div
                  className={classNames(
                    'step-item',
                    step === ApplyStep.Confirm ? 'step-item-active' : ''
                  )}
                >
                  <span className="step-item-num">1</span>
                  <span className="step-item-title">
                    {getFormatMessage('service_confirmation')}
                  </span>
                </div>

                {renderSecondStep()}
                {renderSubmitStep()}
              </div>
              {renderServicesConfirm()}
              {renderInformationFilling()}
              {renderShop()}
            </div>
          ) : (
            <div className="success-box">
              <img src={successCircle} className="success-icon" />
              <div className="success-tips">
                {getFormatMessage('apply_submit_tips', {
                  params: {
                    service: props.selectedServiceConfig?.Name,
                  },
                })}
              </div>
              <div className="success-contact-us">
                <span onClick={openContactMethod}>
                  {getFormatMessage('contact_us_upper')}
                </span>
              </div>
              <div className="success-ok" onClick={onClose}>
                {getFormatMessage('apply_complete_btn')}
              </div>
            </div>
          )}
        </div>
      </ModalWrap>
      {renderConfirmDmp()}
    </div>
  );
};
